import * as Vue from 'vue'
import * as mutations from "./mutation-types"

export const processProposalStats = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_PROPOSAL_STATS, item)
}

export const fetchProposalStats = (store, params) => {
    return axios.get(`/api/proposal-stats`, { params })
        .then(res => {
            _.each(res.data.data, item => processProposalStats(store, item))
            return res
        })
}

export const processApplicationUnderReview = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_APPLICATION_UNDER_REVIEW, item)
}

export const fetchApplicationsUnderReview = (store, params) => {
    return axios.get(`/api/applications/under-review`, { params })
        .then(res => {
            // Vue.ref(store.state, 'applicationsUnderReview', [])
            store.state.applicationsUnderReview = []
            _.each(res.data.data, item => processApplicationUnderReview(store, item))
            return res
        })
}

export const processApplicationSignedOff = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_APPLICATION_SIGNED_OFF, item)
}

export const fetchApplicationsSignedOff = (store, params) => {
    return axios.get(`/api/applications/signed-off`, { params })
        .then(res => {
            // Vue.reactive(store.state, 'applicationsSignedOff', [])
            store.state.applicationsSignedOff = []
            _.each(res.data.data, item => processApplicationSignedOff(store, item))
            return res
        })
}

export const fetchApplicationsUnderReviewStats = (store, params) => {
    return axios.get(`/api/applications/under-review/stats`, { params })
}

export const fetchApplicationsSignedOffStats = (store, params) => {
    return axios.get(`/api/applications/signed-off/stats`, { params })
}